export const SET_CONTENTHASH_ABI = [
  {
    name: 'setContenthash',
    type: 'function',
    inputs: [{ name: 'node', type: 'bytes32' }, { name: 'hash', type: 'bytes' }],
    outputs: [],
  },
];
